import {Async, Empty} from 'Core/models/Async';
import {Link} from 'Core/models/Page';
import {createAction} from 'Shared/utilities/actionCreator';

export enum RateGeneratorActionType {
  GET_RATE_GENERATORS = 'GET_RATE_GENERATORS',
  CHANGE_RATE_GENERATORS = 'CHANGE_RATE_GENERATORS',
}

export const getRateGenerators = (encryptedIdentifier: string) =>
  createAction(RateGeneratorActionType.GET_RATE_GENERATORS, {encryptedIdentifier});

export const changeRateGenerators = (rateGenerators: Async<Link[]>) =>
  createAction(RateGeneratorActionType.CHANGE_RATE_GENERATORS, rateGenerators);

export type RateGeneratorsState = {
  rateGenerators: Async<Link[]>;
};

type RateGeneratorAction = ReturnType<typeof changeRateGenerators>;

const DEFAULT_STATE = {
  rateGenerators: new Empty(),
};

export default (state: RateGeneratorsState = DEFAULT_STATE, action: RateGeneratorAction): RateGeneratorsState => {
  switch (action.type) {
    case RateGeneratorActionType.CHANGE_RATE_GENERATORS:
      return {
        ...state,
        rateGenerators: action.payload,
      };
    default:
      return state;
  }
};
